import { render, staticRenderFns } from "./FabricCompositionInput.vue?vue&type=template&id=4587e006&scoped=true"
import script from "./FabricCompositionInput.vue?vue&type=script&lang=js"
export * from "./FabricCompositionInput.vue?vue&type=script&lang=js"
import style0 from "./FabricCompositionInput.vue?vue&type=style&index=0&id=4587e006&prod&scoped=true&lang=css"
import style1 from "./FabricCompositionInput.vue?vue&type=style&index=1&id=4587e006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4587e006",
  null
  
)

export default component.exports